// libraries
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'

// types
interface NavigationCardsProps {
    className?: string
    isAnimated?: boolean
    title?: string
    intro?: string
    cards?: {
        color?: 'green' | 'green-light' | 'beige'
        icon?: string
        label?: string
        href?: {
            href?: string
            external?: boolean
        }
    }[]
}

// css
import './index.scss'

export default function NavigationCards({
    className,
    isAnimated,
    title,
    intro,
    cards
}: NavigationCardsProps) {
    return (
        <Section className={clsx(
            'navigation-cards-component',
            className
        )}>
            <div className='container'>

                {title && (
                    <h2 className='h2'>
                        {title}
                    </h2>
                )}

                {intro && (
                    <div
                        className='body navigation-cards-component__intro'
                        dangerouslySetInnerHTML={{
                            __html: intro
                        }}
                    />
                )}

                {cards && (
                    <div
                        className={clsx(
                            'navigation-cards-component__cards',
                            cards?.length === 1 && 'navigation-cards-component__cards--1',
                            cards?.length === 2 && 'navigation-cards-component__cards--2',
                            cards?.length === 3 && 'navigation-cards-component__cards--3',
                            cards?.length >= 4 && 'navigation-cards-component__cards--4'
                        )}
                        data-stagger-up={isAnimated ? 'true' : 'false'}
                    >
                        {cards?.map((item, i) => (
                            <a
                                className='navigation-cards-component__card'
                                href={item.href?.href}
                                target={item.href?.external ? '_blank' : undefined}
                                rel={item.href?.external ? 'noopener noreferrer' : undefined}
                                key={i}
                            >
                                
                                <span className={clsx(
                                    'icon',
                                    item.color === 'green' && 'bg-green',
                                    item.color === 'green-light' && 'bg-green-light',
                                    item.color === 'beige' && 'bg-beige',
                                )}>
                                    <img
                                        src={item.icon}
                                        alt={item.label}
                                        width={64}
                                        height={64}
                                        loading='lazy'
                                    />
                                </span>

                                {item.label && (
                                    <span className='h3'>
                                        {item.label}
                                    </span>
                                )}

                            </a>
                        ))}
                    </div>
                )}

            </div>
        </Section>
    )
}